class Sidebar {
  constructor() {
    this.initialize();
  }

  initialize() {}

  toggle() {}

  open() {}

  close() {}
}

export default Sidebar;

document.addEventListener("DOMContentLoaded", function () {
  const sidebar = new Sidebar();
  check_sidebar_status();
});

$(".nav-link").click(function (e) {
  if ($(this).hasClass("active") == true) {
    return false;
  }

  var componentName = $(this).attr("data-componentName");
  var controllerName = $(this).attr("data-controllerName");

  var link = $(this).attr("data-link");

  $(".nav-link").removeClass("active");
  $(".nav-link").parent().removeClass("active");
  $(this).addClass("active");
  $(this).parent().addClass("active");

  if ($(this).closest(".dynamic").length) {
    window.history.pushState(null, "micromarin", link);
  } else {
    if ($(this).hasClass("appSetting")) {
      if (controllerName.includes("appSetting")) {
        window.history.pushState(
          null,
          "micromarin",
          "/company-setting/company-applications/" + controllerName + "/" + componentName,
        );
      }
    } else if ($(this).hasClass("website")) {
      window.history.pushState(null, "micromarin", "/" + componentName);
    } else {
      window.history.pushState(null, "micromarin", "/" + controllerName + "/" + componentName);
    }
  }

  GetPageViewComponent(componentName, $("#main-container"));

  return false;
});

$(".mm-sidebar-sticky").dxScrollView({
  scrollByContent: true,
  scrollByThumb: true,
});

$(".hamburger").click(function () {
  var sidebarMenu = $.cookie("sidebarMenu");
  if (sidebarMenu == undefined || sidebarMenu == "open") {
    $(".wrapper").addClass("active");
    $.removeCookie("sidebarMenu", { path: "/" });
    $.cookie("sidebarMenu", "close", { path: "/" });
    $(".mm-sidebar-logo-text").addClass("d-none");
    $(".mm-sidebar-dashboard-app").addClass("d-none");
    $('.mm-sidebar [data-bs-toggle="tooltip"]').tooltip("enable");
  } else {
    $(".wrapper").removeClass("active");
    $.removeCookie("sidebarMenu", { path: "/" });
    $.cookie("sidebarMenu", "open", { path: "/" });
    $(".mm-sidebar-logo-text").removeClass("d-none");
    $(".mm-sidebar-dashboard-app").removeClass("d-none");

    $('.mm-sidebar [data-bs-toggle="tooltip"]').tooltip("disable");
  }
});

$(".mm-sidebar-footer-hamburger").click(function () {
  var sidebarMenu = $.cookie("sidebarMenu");
  if (sidebarMenu == undefined || sidebarMenu == "open") {
    setSidebarState("close");
  } else {
    setSidebarState("open");
  }
});

function setSidebarState(state) {
  $.removeCookie("sidebarMenu", { path: "/" });
  $.cookie("sidebarMenu", state, { path: "/" });
  applySidebarState(state);
}

function applySidebarState(state) {
  var isClosed = state == "close";

  $(".wrapper").toggleClass("active", isClosed);
  $(".mm-sidebar-logo-text").toggleClass("d-none", isClosed);
  $(".mm-sidebar-dashboard-app").toggleClass("d-none", isClosed);

  if (isClosed) {
    $('.mm-sidebar [data-bs-toggle="tooltip"]').tooltip("enable");
  } else {
    // Hamburger'ın tooltip'i sidebar açıkken de çalışmalı, onu hariç tut
    $('.mm-sidebar [data-bs-toggle="tooltip"]')
      .not(".mm-sidebar-footer-hamburger")
      .tooltip("disable");
    $(".mm-sidebar-footer-hamburger").tooltip("enable");
  }

  updateHamburgerTooltip(isClosed);
}

function updateHamburgerTooltip(isClosed) {
  var $el = $(".mm-sidebar-footer-hamburger");
  if (!$el.length) return;

  var newTitle = isClosed ? "Expand sidebar" : "Collapse sidebar";
  $el.attr("data-bs-original-title", newTitle);

  var instance = bootstrap.Tooltip.getInstance($el[0]);
  if (instance) {
    instance.hide(); // toggle anında açık kalan tooltip'i kapat
  }
}

function check_sidebar_status() {
  var sidebarMenu = $.cookie("sidebarMenu");
  var state = sidebarMenu == undefined || sidebarMenu == "open" ? "open" : "close";
  applySidebarState(state);
}

$(window).on("resize", function () {
  if ($(window).width() <= 1200) {
    applySidebarState("close");
  } else {
    applySidebarState("open");
  }
});